import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle'

@Component({
  selector: 'cft-contact-bottom-navigation',
  templateUrl: './contact-bottom-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContactBottomNavigationComponent {
  @Input() benefits: string[] = []
  @Input() showGuarantee = false

  readonly checkIcon = faCheckCircle
}
